type CheckoutCardProps = {
  children: React.ReactNode;
  isAvailable?: boolean;
  className?: string;
};

export default function CheckoutCard({ children, isAvailable = true, className = '' }: CheckoutCardProps) {
  return (
    <div
      className={`border rounded-xl p-4 relative transition-opacity duration-300 ${
        !isAvailable ? 'opacity-50 pointer-events-none' : 'opacity-100'
      } ${className}`}
    >
      {children}
    </div>
  );
}
